import { Component, input } from '@angular/core';

@Component({
  selector: 'app-counter-badge',
  imports: [],
  templateUrl: './counter-badge.component.html',
  styleUrl: './counter-badge.component.scss'
})

/**
 * Komponente zur Anzeige eines Zählers (Counter Badge) in der Benutzeroberfläche.
 *
 * Begründung:
 * Wiederverwendbare Komponente, die ausschließlich Designzwecken dient.
 */
export class CounterBadgeComponent {
  count = input<number>();
  dataTestId = input<string>();
  dataTestIdMention = input<string>();
  isMentioned = input<boolean>();
}
